import styled from "styled-components";

const RestaurantCardStyles = styled.div`
  font-size: 16px;
  line-height: 22px;

  &:last-child > div {
    /* border-bottom: none; */
    margin-bottom: 15px;
  }

  .article-link {
    color: var(--cornflower);
    /* white-space: nowrap; */

    &:after {
      content: "and ";
      color: var(--off-black);
      cursor: default;
    }

    &:last-child {
      &:after {
        content: none;
      }
    }
  }

  .highlighted-restaurant {
    background: var(--ts-tan);
    text-align: center;
    color: var(--off-black);
    padding: 4px 8px 6px;
    margin-bottom: 18px;
    width: 364px !important;
    border-radius: 10px;
  }

  .restaurant-card {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: left;
    width: 364px;
    padding-bottom: 50px;
    margin-bottom: 30px;
    /* padding-right: 20px; */
    border-bottom: 2px solid var(--light-gray);

    &__name {
      font-family: var(--header-font);
      font-weight: normal;
      color: var(--off-black);
      font-weight: normal !important;
      font-size: 28px;
      line-height: 34px;
      margin-bottom: 2px;
    }

    &__photo {
      height: 200px;
      width: 364px;
      object-fit: cover;
      margin-bottom: 4px;
      /* border: 1px solid var(--off-black); */
      background-color: var(--light-gray);
    }

    &__map-point {
      position: absolute;
      right: -15px;
      bottom: 33px;
      margin-right: 16px;
      height: 37px;
      width: 37px;
      border: 1px solid black;
      border-radius: 100px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      z-index: 99999;

      svg {
        cursor: pointer;
        /* &:hover #Oval-2 {
          fill: var(--cornflower);
        } */
      }
    }

    &__contact {
      position: relative;
      bottom: -8px;

      /* text-align: center; */
      /* margin-bottom: 16px; */

      &-and-map-point {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      a {
        line-height: 22px;
        color: var(--cornflower);
      }

      a:after {
        content: "| ";
        color: var(--off-black);
        cursor: default;
      }

      a:last-child:after {
        content: none;
      }
    }

    &__description {
      margin-bottom: 12px;
      line-height: 20px;
    }

    &__info-row {
      display: flex;
      flex-flow: row nowrap;
      margin-bottom: 4px;

      h4 {
        font-family: var(--header-font-bold);
        font-weight: normal !important;
        line-height: 23px;
        font-size: 17px;
        margin-top: 2px;
        width: 105px;
      }

      &--values {
        /* margin-top: 6px; */
        /* margin-bottom: 0; */
      }
    }

    &__tags {
      display: flex;
      flex-flow: row wrap;
      white-space: pre;
      width: 300px;

      p {
        line-height: 24px;
      }

      p:after {
        content: ", ";
      }

      p:last-child:after {
        content: "";
      }
    }

    &__disabled-text {
      color: #8b8b8b !important;
    }

    &__icons {
      width: 300px;
      position: relative;
      left: -8px;
    }

    &__share-item {
      display: none;
      opacity: 0;
      transition: all 0.2s;
      transform: translateX(10px);
      padding-top: 5px;

      &:last-child {
        padding-left: 10px;
      }
    }

    &__share-collection {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      transform: translate(-2px, -4px);
    }

    &__buttons {
      position: absolute;
      bottom: 27px;
      right: 0;
      margin-right: 45px;
      z-index: 100000;
      display: flex;
      flex-direction: row-reverse;

      &:hover > div > .restaurant-card__share-item {
        display: block;
        opacity: 1;
        transform: translateX(0px);
        cursor: pointer;
      }

      &:hover > .restaurant-card__share-collection {
        /* background: white; */
        /* border: 1px solid var(--off-black); */
        /* height: 50px; */
        /* border-radius: 100px; */
      }

      //stop buttons from moving up on hover
      &:hover {
        bottom: 24px;
      }

      &--copy {
        margin-right: 8px;
        transition: all ease 0.1s;

        &:active,
        &:focus {
          outline: none;
          opacity: 1 !important;
        }

        &:hover {
          outline: none;
          opacity: 0.8;
        }
      }

      svg {
        cursor: pointer;
      }

      div {
        button {
          margin: 0;
          margin-right: 8px;
          outline: none;
          transition: all ease 0.1s;

          &:active,
          &:focus {
            outline: none;
            opacity: 1 !important;
          }

          &:hover {
            outline: none;
            opacity: 0.8;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1145px) and (pointer: coarse) {
    .highlighted-restaurant {
      width: calc(100% + 10px) !important;
    }

    .restaurant-card {
      width: calc(100vw - 24px);
      padding-right: 10px;

      &__name {
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
        max-width: calc(100vw - 60px);
        -ms-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
      }

      &__phone {
        white-space: nowrap;
      }

      &__tags {
        width: calc(100% - 100px);
      }

      &__info-row {
        h4 {
          width: 100px !important;
        }
      }

      &__icons {
        width: calc(100% - 100px);
        position: relative;
        left: -8px;
      }

      &__buttons {
        /* bottom: 0px; */
        /* right: -15px; */
        /* margin-right: 16px; */
        /* margin-bottom: 10px; */

        //stop buttons from moving up on hover
        /* &:hover {
          bottom: -6px;
        } */
      }
    }
  }
`;

export default RestaurantCardStyles;
